import React, { useEffect, useState } from "react";
import logo from "./assets/images/logo.png";
import { Link, NavLink } from "react-router-dom";
import {
  Navbar,
  Nav,
  Container,
  Offcanvas,
  Row,
  Col,
  NavDropdown,
} from "react-bootstrap";
import axios from "axios";
import { MyApi } from "./MyApi";

function HeaderTop() {
  const [show, setShow] = useState(false);
  const [setting, setSetting] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  /* Fetch site settings */
  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + "site-setting",
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data?.status && res.data?.data) {
          setSetting(res.data.data);
        }
      } catch (error) {
        console.error("Failed to load site settings", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSetting();
  }, []);

  /* Fetch Services */
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.CAT_MENU,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );
        if (res.data.status) {
          setServices(res.data.data);
        }
      } catch (err) {
        console.error("Menu API error:", err);
      }
    };

    fetchServices();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="header_sty">

      {/* Top Bar */}
      <div className="head_top">
        <Container>
          <Row className="align-items-center">
            <Col>
              <ul>
                {setting?.mobile && (
                  <li>
                    <a href={`tel:${setting.mobile}`}>
                      <i className="bi bi-telephone-forward"></i>{" "}
                      {setting.mobile}
                    </a>
                  </li>
                )}

                {setting?.emailid && (
                  <li className="d-none d-md-block">
                    <a href={`mailto:${setting.emailid}`}>
                      <i className="bi bi-envelope"></i>{" "}
                      {setting.emailid}
                    </a>
                  </li>
                )}
              </ul>
            </Col>

            <Col className="col-auto">
              <div className="main_menu__social">
                {setting?.facebook && (
                  <a href={setting.facebook} target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                )}

                {setting?.instagram && (
                  <a href={setting.instagram} target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                )}

                {setting?.twitter && (
                  <a href={setting.twitter} target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-x-twitter"></i>
                  </a>
                )}

                {setting?.youtube && (
                  <a href={setting.youtube} target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Navbar */}
      <Navbar expand="lg" className="shadow-sm menu_style">
        <Container>
          <div className="d-flex align-items-center justify-content-between wmob100">
            <Navbar.Brand as={Link} to="/">
              <img src={logo} alt="logo" />
            </Navbar.Brand>

            <Navbar.Toggle onClick={handleShow}>
              <i className="fa-solid fa-bars"></i>
            </Navbar.Toggle>
          </div>

          <Navbar.Offcanvas
            show={show}
            onHide={handleClose}
            placement="start"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                <img src={logo} alt="" height="40" />
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">

                <NavLink className="nav-link" to="/" onClick={handleClose}>
                  Home
                </NavLink>

                <NavLink className="nav-link" to="/about-us" onClick={handleClose}>
                  About Us
                </NavLink>

                <NavLink className="nav-link" to="/s/our-services" onClick={handleClose}>
                  Services
                </NavLink>

                {/* Dynamic Dropdown */}
                <NavDropdown title="Tour Packages" id="tours-dropdown">
                  {services.length > 0 ? (
                    services.map((item) => (
                      <NavDropdown.Item
                        as={Link}
                        to={`/tour-packages/${item.categoryurl}`}
                        key={item.id}
                        onClick={handleClose}
                      >
                        {item.categoryheading}
                      </NavDropdown.Item>
                    ))
                  ) : (
                    <NavDropdown.Item disabled>
                      Loading...
                    </NavDropdown.Item>
                  )}
                </NavDropdown>

                <NavLink
                  className="nav-link"
                  to="/services/our-cars-for-rental"
                  onClick={handleClose}
                >
                  Our Cars
                </NavLink>

                <NavLink
                  className="nav-link"
                  to="/services/top-routes-we-serve"
                  onClick={handleClose}
                >
                  Routes
                </NavLink>

                {/* <NavLink
                  className="nav-link"
                  to="/tours/visit-varanasi"
                  onClick={handleClose}
                >
                  Visit Varanasi
                </NavLink> */}

                <NavLink className="nav-link" to="/reviews" onClick={handleClose}>
                  Reviews
                </NavLink>

                <NavLink
                  className="nav-link"
                  to="/contact-us"
                  onClick={handleClose}
                >
                  Contact Us
                </NavLink>

              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
}

export default HeaderTop;